/* eslint-disable */
export default {
  downloadSuccess: 'Protokoll heruntergeladen.',
  downloadFail:
    'Das Herunterladen des Fehlerprotokolls ist fehlgeschlagen. Versuchen Sie es erneut.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
